import { CFC } from "@api/types/cypress";
import Error from "@api/types/error";
import React from "react";

const Select: CFC<{
  field: string;
  value: string;
  defaultOption?: { label: string; value: string };
  options: { label: string; value: string }[];
  error: Error;
  locked: boolean;
  onChange: (field: string, value: string) => void;
}> = ({ field, value, defaultOption = { label: "Select", value: "" }, options, error, locked, onChange }) => (
  <div className="select-container">
    <select
      className={error.active ? "error" : ""}
      value={value}
      disabled={locked}
      onChange={(e) => onChange(field, e.target.value)}>
      <option value={defaultOption.value}>{defaultOption.label}</option>
      {options.map((option, key) => (
        <option value={option.value} key={key}>
          {option.label}
        </option>
      ))}
    </select>
    <style jsx>
      {`
        .select-container select {
          font-family: sans-serif;
          font-size: 18px;
          border: 1px solid rgb(194, 194, 194);
          outline: none;
          padding: 0.5rem 0.75rem;
          width: 100%;
          appearance: none;
          background-image: url("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+PHBhdGggaWQ9Ikljb25faW9uaWMtaW9zLWFycm93LWRvd24iIGRhdGEtbmFtZT0iSWNvbiBpb25pYy1pb3MtYXJyb3ctZG93biIgZD0iTTMyLDM0LjY4bDguOTMtOC45NGExLjY3LDEuNjcsMCwwLDEsMi4zNywwaDBhMS43MiwxLjcyLDAsMCwxLDAsMi40TDMzLjIxLDM4LjI2YTEuNjgsMS42OCwwLDAsMS0yLjMzLjA1TDIwLjY5LDI4LjE0YTEuNjksMS42OSwwLDEsMSwyLjM4LTIuMzlaIi8+PC9zdmc+");
          background-repeat: no-repeat;
          background-position-x: calc(100% - 8px);
          background-position-y: 1px;
        }

        .select-container select.error {
          border-color: red;
        }

        @media screen and (min-width: 768px) {
          .select-container select {
            width: 50%;
          }
        }
      `}
    </style>
  </div>
);

export default Select;
